import { Typography } from "@material-ui/core";
import React from "react";

interface ErrorTextProps {
  error: any;
  serverError: any;
}

const ErrorText: React.SFC<ErrorTextProps> = props => {
  const { error, serverError } = props;

  return (
    <>
      {Object.values(error).map(err => (
        <Typography variant="caption" color="error">
          {err}
        </Typography>
      ))}
      {Object.values(serverError).map(err => (
        <Typography variant="caption" color="error">
          {err}
        </Typography>
      ))}
    </>
  );
};

export default ErrorText;
